import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const updateModelSelectionKeys =
  (updatedKeys: Record<string, string>) => (model: Model) => {
    const selection = model.modelData.selection.map(
      (key) => updatedKeys[key] || key
    );
    setDataProperty<ModelData>(model)(model.modelData, 'selection', selection);
  };
